module.exports = __webpack_public_path__ + "img/ring_r_o_0_1@3x.4f339c10.png";